import logo from "@/assets/root-logo.png";
import { richTextToComponents, useGetLatestReleaseNotes } from "@/hooks/useContentful";
import { usePatchUserSettings, useUserSettings } from "@/hooks/useUserSettings";
import { Image, Modal } from "antd";
import { Fragment } from "react";
import "./NewVersionModal.scss";

export default function NewVersionModal() {
  const userSettings = useUserSettings();
  const patchUserSettings = usePatchUserSettings();
  const releaseNotes = useGetLatestReleaseNotes();

  const closeNewVersionModal = () => {
    if (releaseNotes.data) {
      patchUserSettings.mutate({ latest_release_notes_id: releaseNotes.data.sys.id });
    }
  };

  const releaseItems = [
    ...(releaseNotes.data?.fields.heading1 && releaseNotes.data?.fields.description1
      ? [
          {
            title: releaseNotes.data.fields.heading1,
            description: releaseNotes.data.fields.description1,
            image: releaseNotes.data.fields.image1,
          },
        ]
      : []),
    ...(releaseNotes.data?.fields.heading2 && releaseNotes.data?.fields.description2
      ? [
          {
            title: releaseNotes.data.fields.heading2,
            description: releaseNotes.data.fields.description2,
            image: releaseNotes.data.fields.image2,
          },
        ]
      : []),
    ...(releaseNotes.data?.fields.heading3 && releaseNotes.data?.fields.description3
      ? [
          {
            title: releaseNotes.data.fields.heading3,
            description: releaseNotes.data.fields.description3,
            image: releaseNotes.data.fields.image3,
          },
        ]
      : []),
  ];

  return (
    <Modal
      open={
        userSettings.data &&
        releaseNotes.data &&
        userSettings.data?.latest_release_notes_id !== releaseNotes.data?.sys.id
      }
      onCancel={() => closeNewVersionModal()}
      width={750}
      footer={null}
      className={"NewVersionModal"}
    >
      <div style={{ background: "#fff8e8", textAlign: "center", padding: 24 }}>
        <Image
          src={logo}
          preview={false}
          alt={"root-logo"}
          height={27}
          width={104}
          style={{ marginTop: 10 }}
        />
        <h1 style={{ marginTop: 30 }}>{releaseNotes.data?.fields.title}</h1>
        {richTextToComponents(releaseNotes.data?.fields.introduction)}
      </div>
      <div style={{ padding: 24 }}>
        <h2>Here's what's new ✨</h2>
        {releaseItems.map((item) => {
          return (
            <Fragment key={item?.title}>
              <h3>{item?.title}</h3>
              {richTextToComponents(item?.description)}
              {item?.image && (
                <div style={{ padding: 36 }}>
                  <Image
                    src={item.image?.fields.file?.url}
                    alt={item.title}
                  />
                </div>
              )}
            </Fragment>
          );
        })}
        {richTextToComponents(releaseNotes.data?.fields.closing)}
      </div>
    </Modal>
  );
}
